/**
 * Single source of truth for the named text colors used in announcement
 * markdown — across editor (TextColorMark), display (MarkdownWidgetDisplay)
 * and the toolbar swatches (MarkdownEditor).
 *
 * Color name → Tailwind class. Stored in markdown as
 * `<span data-color="NAME">…</span>`; the visual color is applied at render
 * time by mapping NAME → class through this table, so design tokens stay the
 * single source of truth (no separate CSS rules or hand-maintained lists).
 *
 * Keep in sync with the PHP allowlist in
 * `Core\Communication\Base\Support\ContentNormalizer`. The TS↔PHP parity is
 * enforced by `tests/Unit/Core/Communication/Base/Support/TextColorParityTest.php`.
 */
export const TEXT_COLORS = {
  red: 'text-destructive',
  orange: 'text-orange-500',
  green: 'text-emerald-600',
  blue: 'text-blue-600',
} as const

export type TextColorName = keyof typeof TEXT_COLORS

export const TEXT_COLOR_NAMES = Object.keys(TEXT_COLORS) as readonly TextColorName[]

export const TEXT_COLOR_NAME_SET: ReadonlySet<string> = new Set(TEXT_COLOR_NAMES)

export function textColorClass(name: string): string | null {
  return name in TEXT_COLORS ? TEXT_COLORS[name as TextColorName] : null
}
